import { render, staticRenderFns } from "./DomainWhitelist.vue?vue&type=template&id=5c3f482e&"
import script from "./DomainWhitelist.vue?vue&type=script&lang=ts&"
export * from "./DomainWhitelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports